import DOMPurify from 'dompurify';
import { Log } from 'helpers/errorLogger';
import React, { useEffect, useState } from 'react';
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { isStringHtml } from 'helpers/utils/isStringHtml';
//@ts-ignore
import { markdown as MD } from 'markdown';

export interface Props {
  markdown: string;
  className?: string;
}

const Markdown: React.FC<Props> = ({ markdown, className }) => {
  const [safeMarkdown, setSafeMarkdown] = useState('');

  useEffect(() => {
    if (isStringHtml(markdown)) {
      setSafeMarkdown(markdown);
    } else if (typeof markdown === 'string') setSafeMarkdown(DOMPurify.sanitize(MD.toHTML(markdown)));
  }, [markdown]);

  if (typeof markdown !== 'string') {
    Log.error(new Error(`Markdown: Invalid markdown property. Expected string but received ${typeof markdown}`));

    return <></>;
  }

  return (
    <>
      <div data-id="markdown-content" className={className} dangerouslySetInnerHTML={{ __html: safeMarkdown }}></div>
    </>
  );
};

export default Markdown;
